import { Item } from '@/types/item/Item';

export type CarouselServerResponse = {
    items: Item[];
    title: string;
    viewMoreUrl: string;
};

// SEAR-69 EXPERIMENT: Added items to the carousel type to support the New Similar Items carousel.
export type Carousel = {
    itemIds: number[];
    items?: {
        items: Item[];
        lotsClosed: number;
        pageCount: number;
        recordCount: number;
        totalRecords: number;
    };
    title: string;
    viewMoreUrl: string;
};

export const emptyCarousel: Carousel = {
    itemIds: [],
    title: '',
    viewMoreUrl: '',
};

export type FetchItemCarouselsPayload = {
    carousels: CarouselServerResponse[];
    itemId: number;
};

export type FetchItemCarouselsResponse = {
    error: boolean;
    payload: CarouselServerResponse[];
};

/**
 * @category Search API
 * @see api.fetchItemCarousels
 * @see https://liveauctioneers.atlassian.net/browse/SW-958
 */
export type FetchItemCarouselsParams = {
    /** The IP Address of the client, for SSR passthrough */
    ipAddress: string;
    /** The is the client a bot for SSR passthrough */
    isBot: boolean;
    /** The item for which to return the carousels for */
    itemId: number;
    /** Whether to include Chairish similar items in the response */
    useChairishSimilarItems?: boolean;
    /** Whether to use the feature flag variant response */
    useNewSimilarItems?: boolean;
    /** Whether to use the scout variant response */
    useScoutCategories?: boolean;
    /** Whether to use the signals boost variant response */
    useSignalsBoost?: boolean;
    /** Routes similar-lots through a specific embedding version when set (omitted for control) */
    vectorVersion?: string;
};

export type ItemCarouselState = {
    byId: { [id: number]: Carousel[] };
    errored: { [id: number]: boolean };
    loaded: { [id: number]: number };
    loading: boolean;
};

export const defaultItemCarouselState: ItemCarouselState = {
    byId: {},
    errored: {},
    loaded: {},
    loading: false,
};
